import { HeaderButton } from '@/components/HeaderButton';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import { TemplateGalleryModal } from '@/components/Modals/TemplateGalleryModal';
import { upgradeFreePlanModalOpen } from '@/components/Modals/UpgradeFreePlanModal';
import { useNavigateToAdvancedEditor } from '@/hooks/navigation';
import { useFreeVideos } from '@/hooks/useFreeVideos';
import Plus from '@/images/plus.svg';
import { useFlag } from '@/services/featureFlags';
import { useTemplateGalleryModal } from '@/state/template-gallery/useTemplateGalleryModal';
import { useTheme } from '@mui/material';
import { useSetRecoilState } from 'recoil';

export const CreateProjectButton = () => {
    const { navigateToAdvancedEditor, isLoading } = useNavigateToAdvancedEditor();
    const theme = useTheme();
    const { outOfFreeVideos } = useFreeVideos();
    const setUpgradeFreePlanModalOpen = useSetRecoilState(upgradeFreePlanModalOpen);
    const { open, isVisuallyOpen } = useTemplateGalleryModal();
    const isTemplateGalleryEnabled = useFlag('template_gallery_v2', false);

    const handleClick = async () => {
        if (outOfFreeVideos) {
            setUpgradeFreePlanModalOpen(true);
            return;
        }

        if (isTemplateGalleryEnabled) {
            open();
            return;
        }

        await navigateToAdvancedEditor({ mixPanelFrom: 'header-button' });
    };

    return (
        <>
            <HeaderButton
                id="create-video-btn"
                data-testid="studio-create-video-button"
                onClick={handleClick}
                aria-label="create video"
                isLoading={isLoading}
                loadingText="Create video">
                <MaskedIcon color={theme.colors.black.main} src={Plus} size="16px" />
                Create video
            </HeaderButton>
            {isVisuallyOpen && <TemplateGalleryModal from="Videos" />}
        </>
    );
};
